import { eCommentType } from './eCommentType';

export const internalCommentTypes = [
  eCommentType.accountVerification,
  eCommentType.closing,
  eCommentType.curative,
  eCommentType.escrowOps,
  eCommentType.examination,
  eCommentType.funding,
  eCommentType.general,
  eCommentType.inboundCall,
  eCommentType.orderManagement,
  eCommentType.policy,
  eCommentType.postClosing,
  eCommentType.postClosingEscalation,
  eCommentType.postFunding,
  eCommentType.postSigning,
  eCommentType.questionnaire,
  eCommentType.recording,
  eCommentType.recordingOverage,
  eCommentType.recordingShortage,
  eCommentType.search,
  eCommentType.shortage,
  eCommentType.signing,
  eCommentType.underwriting,
  eCommentType.tenNinetyNine,
];
